module.exports = __webpack_public_path__ + "img/weChatPhone.efb2c416.png";